/**
 * Menu utilities for permission-based filtering and identifier extraction
 */

/**
 * Recursively extracts all feature identifiers from menu items
 * @param {Array} items - Menu items with featureId and optional subMenu
 * @return {Set} Set of unique feature identifiers
 */
export const extractIdentifiers = (items) => {
  const identifiers = new Set();

  const extract = (items) => {
    items.forEach((item) => {
      identifiers.add(item.featureId);
      if (item.subMenu && item.subMenu.length > 0) {
        extract(item.subMenu);
      }
    });
  };

  extract(items);
  return identifiers;
};

/**
 * Filters and maps menu objects based on allowed identifiers
 * Recursively processes children/subMenu items
 * @param {Array} mainObject - Array of menu items
 * @param {Set} identifiers - Set of allowed identifiers
 * @return {Array} Filtered menu items
 */
export const filterAndMapObjects = (mainObject, identifiers) => {
  const filterSubMenu = (subMenu) => {
    return subMenu
      .filter((item) => identifiers.has(item.identifer))
      .map((item) => ({
        ...item,
        children: item.children ? filterSubMenu(item.children) : [],
      }));
  };

  return mainObject
    .filter((item) => identifiers.has(item.identifer))
    .map((item) => ({
      ...item,
      children: item.children ? filterSubMenu(item.children) : [],
    }));
};
